/**
 * RBAC types — menu/permission interfaces and the PermissionAction enum.
 *
 * PermissionAction integer values are taken verbatim from:
 * Backend/LILNS_ITOW_DES/COMMON/ENUMS/PermissionEnum.cs
 *   enum TypePermissionAction : short { GET = 1, POST, PUT, DELETE }
 * i.e. GET=1, POST=2, PUT=3, DELETE=4.
 */

/** Mirrors backend MenuDTO / Angular IMenu. */
export interface MenuItem {
  id: number;
  name: string;
  unique: boolean;
  route: string;
  icon: string;
  iconType: string;
  selected: boolean;
  permission: number[];
  subMenus: SubMenuItem[];
  /** Multilanguage label from Angular labelTranslate. */
  labelTranslate: string;
}

/** Mirrors backend SubMenuDTO / Angular ISubMenus. */
export interface SubMenuItem {
  id: number;
  name: string;
  route: string;
  icon: string;
  iconType: string;
  selected: boolean;
  permission: number[];
  unique: boolean;
  isMenu: boolean;
  labelTranslate: string;
}

/**
 * Maps directly to TypePermissionAction in the .NET backend.
 * Source: Backend/LILNS_ITOW_DES/COMMON/ENUMS/PermissionEnum.cs
 */
export enum PermissionAction {
  GET = 1,
  POST = 2,
  PUT = 3,
  DELETE = 4,
}
